import type { ReactNode } from 'react';

interface CalloutProps {
  tone?: 'info' | 'warning' | 'error';
  title?: string;
  children: ReactNode;
}

/**
 * Status messaging. Always icon + text — a status colour never carries meaning alone
 * (two of the four status steps sit below 3:1 on a light surface by design).
 */
export function Callout({ tone = 'info', title, children }: CalloutProps) {
  const icon = tone === 'error' ? '✕' : tone === 'warning' ? '!' : 'i';

  return (
    <div className={`callout callout-${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <span className="callout-icon" aria-hidden="true">
        {icon}
      </span>
      <div>
        {title && <strong className="t-heading" style={{ display: 'block' }}>{title}</strong>}
        <div className="t-body">{children}</div>
      </div>
    </div>
  );
}
